import * as React from 'react'

import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

import BackgroundImage from 'components/atomic/atoms/bg-image'
import Button from 'components/atomic/atoms/button'
import Text from 'components/atomic/atoms/text'

import Link from 'next/link'

const CtaCard = styled('div')`
    position: relative;
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    border: ${({ theme }) => `1px solid ${theme.palette.divider}`};
`

interface CTASimpleProps {
    title: string
    description: string
    buttonText: string
    buttonLink: string
    color?: string
}

const CTASimple = (props: CTASimpleProps) => {
    return (
        <CtaCard>
            <BackgroundImage filterColor={props.color} imageUrl="/lines2.png" />
            <Box display="flex" flexWrap="wrap" gap={1} m={2}>
                <Box>
                    <Text variant="h5">{props.title}</Text>
                    <Text color="text.secondary" mt={1}>
                        {props.description}
                    </Text>
                </Box>
                <Link href={props.buttonLink} passHref style={{ width: '100%' }}>
                    <a style={{ width: '100%' }}>
                        <Button size="large" variant="contained" fullWidth sx={{ mt: 1 }}>
                            {props.buttonText}
                        </Button>
                    </a>
                </Link>
            </Box>
        </CtaCard>
    )
}

export default CTASimple
